<template>
  <div class="events-upload-image">
    <div class="d-flex">
      <bp-input-file
        v-model="form.picture"
        is-image
        class="mr-lg-8"
        dimensions="256 x 256"
        title="Imagem do produto"
        supporting-text="Imagem exibida no checkout para seus compradores."
      />

      <upload-image-mockup
        :image="form.picture"
        class="d-none d-lg-block ml-6"
      />
    </div>
  </div>
</template>
<script>
import UploadImageMockup from "./UploadImageMockup.vue";
export default {
  components: { UploadImageMockup },
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
